export const MOBILE = 480;
export const TABLET = 768;

export const mobileSize = `${MOBILE}px`;
export const tabletSize = `${TABLET}px`;
